import { useState } from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { SelectField, useRecordContext, Link } from 'react-admin';
import { AntennaAvatar } from '../show/AntennaAvatar';
import { AntennaLight } from '@wwf/sdk';
import { useConfigurationContext } from '@app/root/ConfigurationContext';
import { getLinkToAntenna } from '../getLinkToAntenna';
import { MissionIcon } from '@app/mission/MissionIcon';
import { MemberIcon } from '@app/member/MemberIcon';
import { MediaIcon } from '@app/media/MediaIcon';

export const AntennaCard = (props: { record?: AntennaLight }) => {
    const { antennaTypes } = useConfigurationContext();
    const [elevation, setElevation] = useState(1);
    const record = useRecordContext<AntennaLight>(props);
    if (!record) return null;

    return (
        <Link
            to={getLinkToAntenna(record.id)}
            underline="none"
            onMouseEnter={() => setElevation(3)}
            onMouseLeave={() => setElevation(1)}
        >
            <Paper
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    padding: '1em',
                }}
                elevation={elevation}
            >
                <Box display="flex" flexDirection="column" alignItems="center">
                    <AntennaAvatar variant="md" />
                    <Box textAlign="center" marginTop={1}>
                        <Typography variant="subtitle2">
                            {record.name}
                        </Typography>
                        <SelectField
                            color="textSecondary"
                            source="type"
                            choices={antennaTypes.map(type => ({
                                id: type,
                                name: type,
                            }))}
                        />
                    </Box>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    width="100%"
                    gap={1}
                    marginTop={2}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.2,
                        }}
                    >
                        <MemberIcon />
                        <Typography variant="subtitle2">
                            {record.nbMembers ?? 0}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.2,
                        }}
                    >
                        <MissionIcon />
                        <Typography variant="subtitle2">
                            {record.nbMissions ?? 0}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.2,
                        }}
                    >
                        <MediaIcon />
                        <Typography variant="subtitle2">
                            {record.nbMedias ?? 0}
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        </Link>
    );
};
